var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"stroke":"null","fill-rule":"evenodd","fill":"none"}},[_c('path',{attrs:{"stroke":"null","d":"M19.937 5.984L10 15.921.063 5.984 1.97 4.08l8.03 8.03 8.03-8.03 1.907 1.905z","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }